/**
 * 搜索模式 Tab 切换组件（完全独立）
 *
 * 用于切换工具搜索和 SKILL 搜索
 * 不影响任何现有功能
 */

import React from 'react';
import { Wrench, Sparkles } from 'lucide-react';

export type SearchMode = 'tool' | 'skill';

interface SearchTabSwitchProps {
  currentMode: SearchMode;
  onModeChange: (mode: SearchMode) => void;
  lang?: 'zh' | 'en';
}

export default function SearchTabSwitch({ currentMode, onModeChange, lang = 'zh' }: SearchTabSwitchProps) {
  return (
    <div className="flex justify-center mb-8">
      <div className="flex flex-row items-center bg-gray-100 dark:bg-gray-800 rounded-xl p-1.5 gap-1">
        {/* 工具搜索 Tab */}
        <button
          onClick={() => onModeChange('tool')}
          className={`
            flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all duration-200 whitespace-nowrap
            ${currentMode === 'tool'
              ? 'bg-white dark:bg-gray-700 text-[#165DFF] shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
            }
          `}
        >
          <Wrench className="w-4 h-4" />
          <span>{lang === 'zh' ? '工具搜索' : 'Tools'}</span>
        </button>

        {/* SKILL 搜索 Tab */}
        <button
          onClick={() => onModeChange('skill')}
          className={`
            flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all duration-200 whitespace-nowrap
            ${currentMode === 'skill'
              ? 'bg-white dark:bg-gray-700 text-purple-600 dark:text-purple-400 shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
            }
          `}
        >
          <Sparkles className="w-4 h-4" />
          <span>MCP Skills</span>
        </button>
      </div>
    </div>
  );
}
